import React, { useMemo } from "react";
import LoadingSpinner from "../../../../externalComponents/LoadingSpinner";
import { Text } from "../../../../externalComponents/tailwind/text";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/16/solid";

export default function ContactInformationsSegments({ data, fetching }) {
  const segments = useMemo(() => {
    if (!data) {
      return [];
    }
    return data
      .filter((membership) => membership?.segment)
      .map((membership) => ({
        id: membership.segment.id,
        name: membership.segment.name,
      }))
      .sort((a, b) => (a.name || "").localeCompare(b.name || ""));
  }, [data]);

  const handleSegmentClick = (segmentId) => {
    window.open(`/contacts?segment=${segmentId}`, "_blank");
  };

  return (
    <>
      <Text className="font-bold mt-5 mb-3">Segments</Text>
      {fetching ? (
        <LoadingSpinner />
      ) : segments?.length ? (
        <div className="space-y-1">
          {segments.map((segment) => (
            <div
              key={segment.id}
              className="group relative flex items-center justify-between p-1 bg-gray-50 rounded-lg cursor-pointer hover:bg-gray-100 transition-colors"
              onClick={() => handleSegmentClick(segment.id)}
            >
              <span className="text-sm font-medium text-gray-900">
                {segment.name}
              </span>
              <ArrowTopRightOnSquareIcon className="w-4 h-4 text-gray-400 opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>
          ))}
        </div>
      ) : (
        <div className="text-gray-400 text-xs font-medium">
          No segments found
        </div>
      )}
    </>
  );
}
